<template>
  <footer class="bg-white border-t border-gray-200 mt-auto">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- 회사 정보 -->
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center space-x-2 mb-4">
            <div class="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-sm">S</span>
            </div>
            <span class="text-xl font-bold text-gray-900">Seatisfy</span>
          </div>
          <p class="text-gray-600 text-sm mb-4 max-w-md">
            언제 어디서나 간편하게 좌석을 예약할 수 있는 현대적인 예약 플랫폼입니다. 
            사용자 친화적인 인터페이스와 안전한 예약 시스템을 제공합니다.
          </p>
          <div class="flex space-x-4">
            <a href="#" class="text-gray-400 hover:text-primary-600">
              <span class="sr-only">GitHub</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="#" class="text-gray-400 hover:text-primary-600">
              <span class="sr-only">Twitter</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
          </div>
        </div>

        <!-- 빠른 링크 -->
        <div>
          <h3 class="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
            빠른 링크
          </h3>
          <ul class="space-y-2">
            <li>
              <RouterLink to="/posts" class="text-gray-600 hover:text-primary-600 text-sm">
                게시글 목록
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/posts/create" class="text-gray-600 hover:text-primary-600 text-sm">
                새 글 작성
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/my/reservations" class="text-gray-600 hover:text-primary-600 text-sm">
                내 예약
              </RouterLink>
            </li>
            <li>
              <a href="#" class="text-gray-600 hover:text-primary-600 text-sm">
                도움말
              </a>
            </li>
          </ul>
        </div>

        <!-- 지원 -->
        <div>
          <h3 class="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
            지원
          </h3>
          <ul class="space-y-2">
            <li>
              <a href="#" class="text-gray-600 hover:text-primary-600 text-sm">
                FAQ
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-600 hover:text-primary-600 text-sm">
                고객 지원
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-600 hover:text-primary-600 text-sm">
                이용 약관
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-600 hover:text-primary-600 text-sm">
                개인정보 처리방침
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-200 pt-8 mt-8">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-gray-400 text-sm">
            © 2025 Seatisfy. All rights reserved.
          </p>
          <p class="text-gray-400 text-sm mt-2 md:mt-0">
            Made with ❤️ using Vue 3 and Spring Boot
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>